import { SharedUser } from '../models/user';

/**
 * What a user's mute indicator shows: `'speakers'` while their output is
 * muted, `'mic'` while only their input is off, `null` while they can talk.
 */
export type MuteState = 'speakers' | 'mic' | null;

/**
 * The own user counts as muted without a local audio input; a remote user
 * counts as muted while no audio output for them exists yet.
 * `hasAudioInput` is the own user's local input state and is ignored for
 * remote users.
 */
export function muteStateOf(user: SharedUser, hasAudioInput: boolean): MuteState {
  const muted = user.isSelf
    ? user.data.inputMuted || !hasAudioInput
    : !user.audioOutput || user.data.inputMuted;
  if (!muted) return null;
  return user.data.outputMuted ? 'speakers' : 'mic';
}
